// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bB92b","content":"styles_content__39S70","row":"styles_row__2zNNc","footer":"styles_footer__14Dxp","phraseLength":"styles_phraseLength__3DF-e"};